import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export class UserProcessData {
  DegisKullaniciKod: number;
  DegisTarih: Date;
  KayitKullaniciKod: number;
  KayitTarih: Date;
  actions: string;
  tooltip: string;

  constructor(item?: any) {
    this.DegisKullaniciKod = item?.DegisKullaniciKod || 0;
    this.DegisTarih = item?.DegisTarih || new Date();
    this.KayitKullaniciKod = item?.KayitKullaniciKod || 0;
    this.KayitTarih = item?.KayitTarih || new Date();
    this.actions = item?.actions || 'Action';
    this.tooltip = item?.tooltip || 'Tooltip';
  }
}

@Component({
  selector: 'dk-forms-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './forms-footer.component.html',
  styleUrls: ['./forms-footer.component.scss'],
})
export class FormsFooterComponent {
  @Input() public userProcessData: UserProcessData = new UserProcessData();
}
